import HeaderContainer from '@/app/modules/_shared/layout/header/container/header-container.vue';
import DesktopSidebarContainer from '@/app/modules/_shared/layout/sidebar/container/desktop-sidebar-container/desktop-sidebar-container.vue';
import MobileMenu from '@/app/modules/_shared/layout/mobile-menu/mobile-menu.vue';
import NavMenu from '@/app/modules/_shared/layout/sidebar/components/nav-menu/nav-menu.vue';
import TheLogo from '@/app/modules/_shared/layout/sidebar/components/the-logo/the-logo.vue';
import AppSwitcher from '@/app/modules/_shared/layout/sidebar/components/app-switcher/app-switcher.vue';
import UserMenu from '@/app/modules/_shared/layout/sidebar/components/user-menu/user-menu.vue';

export default {
  name: 'auth-layout',
  components: {
    HeaderContainer,
    DesktopSidebarContainer,
    MobileMenu,
    TheLogo,
    AppSwitcher,
    NavMenu,
    UserMenu,
  },
  computed: {
    auth() {
      return this.$store.getters['auth/loggedIn']
        && this.$route.path !== '/auth/sign-in'
        && this.$route.path !== '/invite';
    },
  },
  data() {
    return {
      mode: 'desktop-sidebar-container',
      mobile: false,
      collapsed: false,
    };
  },
  methods: {
    signOut() {
      this.$store.dispatch('auth/signOut');
      this.$router.push('/auth/sign-in');
    },
    toggleMobile() {
      this.mobile = !this.mobile;
    },
    handleResize() {
      const width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

      this.mobile = width < 769;
      this.mode = this.mobile ? 'mobile-menu' : 'desktop-sidebar-container';
      if (this.mobile) {
        this.$store.dispatch('layout/toggleMenu', false);
      }
    },
    handleAppChange() {
      if (this.mobile) {
        this.$store.dispatch('layout/toggleMenu', false);
      }
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
};
